import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ExternalLink} from './ExternalLink/ExternalLink';
import {ExternalLinkLogos} from './ExternalLinkLogos';
import {EXTERNAL_LINK_SERVICE_ACTION_TYPES, EXTERNAL_LINK_SERVICE_TRANSLATIONS} from './ExternalLinks.constants';
import externalLinksStyles from './ExternalLinks.scss';

function ExternalLinks(props) {
  const {links, onActionButtonClick} = props;
  const {t} = useTranslation();
  const externalLinkNodes = links.map(({service, url}) => {
    const logoSVG = ExternalLinkLogos[service];
    const serviceName = t(EXTERNAL_LINK_SERVICE_TRANSLATIONS[service]);
    const logoAccName = t('mgw.aria.logoAccName', {serviceName});
    const actionType = EXTERNAL_LINK_SERVICE_ACTION_TYPES[service];
    const linkActionName = t(`mgw.externalLinkAction.${actionType.toLowerCase()}`);

    return (
      <li className={externalLinksStyles.externalLinkWrapper} tabIndex={0} key={service}>
        <ExternalLink
          serviceName={serviceName}
          url={url}
          logoSVG={logoSVG}
          logoAccName={logoAccName}
          actionType={actionType}
          service={service}
          onActionButtonClick={onActionButtonClick}
        >
          {linkActionName}
        </ExternalLink>
      </li>
    );
  });
  const externalLinksListAccName = t('mgw.aria.externalLinksList');

  return (
    <ul
      className={externalLinksStyles.externalLinksList}
      tabIndex={0}
      aria-label={externalLinksListAccName}
      data-hook="external-links"
    >
      {externalLinkNodes}
    </ul>
  );
}

ExternalLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      service: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  onActionButtonClick: PropTypes.func,
  t: PropTypes.func,
};

export {ExternalLinks};
